export const SET_THEMES = "SET_THEMES";
export const SET_TEMP_THEME = "SET_TEMP_THEME";
export const SET_TEMP_CHANGED = "SET_TEMP_CHANGED";
export const RESET_THEMES = "RESET_THEMES";
export const RESET_TEMP_THEME = "RESET_TEMP_THEME";
export const ADD_THEME = "ADD_THEME";
export const REMOVE_THEME = "REMOVE_THEME";
export const SELECT_THEME = "SELECT_THEME";
